







































































































import { Meta } from "@/store/meta"
import { Vue, Component, Prop } from "vue-property-decorator"
import { getModule } from "vuex-module-decorators"
@Component({
})
export default class Login extends Vue {
  get loginUrl() {
    return `${process.env.VUE_APP_API_URL}/oauth/login?redirect_uri=${process.env.VUE_APP_CALLBACK_URL}`
  }
  get meta() {
    return getModule(Meta)
  }
  get production() {
    return process.env.NODE_ENV == "production"
  }
}
